module.exports = __webpack_public_path__ + "img/google-play.8c9ba12a.svg";